import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {LoadTargetSuccessAction, targetActionTypes} from '../actions/target-load';

export interface SalesStatisticGoalsState {
  // tslint:disable-next-line:no-any
  array: any[];
}

const initialState: SalesStatisticGoalsState = {
  array: [],
};

export function SalesStatisticGoalsReducer(state: SalesStatisticGoalsState = initialState, action: Action): SalesStatisticGoalsState {
  switch (action.type) {
    case targetActionTypes.LOAD_SUCCESS:
      return handleLoadSalesStatisticGoalsSuccessAction(state, action);
    case targetActionTypes.LOAD_FAIL:
      return handleLoadErrorActions(state);
    default:
      return state;
  }
}
function handleLoadSalesStatisticGoalsSuccessAction(state: SalesStatisticGoalsState, action: LoadTargetSuccessAction): SalesStatisticGoalsState {
  const newState: SalesStatisticGoalsState = {
    ... state,
    array: action.payload.array,
  };
  return newState;
}

function handleLoadErrorActions(state: SalesStatisticGoalsState): SalesStatisticGoalsState {
  return state;
}

export const salesStatisticGoalsStateSelectors = {
  array: (state: SalesStatisticGoalsState) => _.get(state, 'array', []),
};
